// extracted by mini-css-extract-plugin
export default {"container":"wr-z","heading":"xr-z","text":"yr-z","info":"zr-z","link":"Ar-z","fullMaxWidth":"Br-z"};